export const chunckArrayInGroups = (arr: unknown[], size: number) => {
  const chunk = []
  for (let i = 0; i <= arr.length; i += size) chunk.push(arr.slice(i, i + size))
  return chunk
}

export const orderByNumParamAscending = (arr: any, prop: string) => [...arr].sort((a, b) => a[prop] - b[prop]);
